(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["products-under"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window.customElements || customElements.get('products-under-ten')) return;

  class ProductsUnderTen extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add';
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.addedLabel = this.dataset.labelAdded || 'Added to cart';
      this.errorLabel = this.dataset.labelError || 'Could not add to cart';
      this.titleMode = this.dataset.mobileTitleMode || 'tap';

      this.track = this.querySelector('[data-track]');
      this.initCarousel();
      this.initTapTitles();
      this.initForms();
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._onDocPointer) document.removeEventListener('pointerdown', this._onDocPointer);
      clearTimeout(this._toastTimer);
    }

    /* --------------------------- Carousel --------------------------- */
    initCarousel() {
      if (!this.track) return;

      this.querySelectorAll('[data-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = this.track.querySelector('.pu10__card');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
          this.track.scrollBy({ left: Number(button.dataset.scroll) * step, behavior: 'smooth' });
        });
      });

      this.track.addEventListener('scroll', () => {
        if (this._raf) cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => this.syncArrows());
      }, { passive: true });

      this._onResize = () => this.syncArrows();
      window.addEventListener('resize', this._onResize);

      this.syncArrows();
    }

    syncArrows() {
      const prev = this.querySelector('[data-scroll="-1"]');
      const next = this.querySelector('[data-scroll="1"]');
      if (!this.track) return;
      const overflow = this.track.scrollWidth - this.track.clientWidth;
      if (prev) prev.hidden = overflow <= 2 || this.track.scrollLeft <= 2;
      if (next) next.hidden = overflow <= 2 || this.track.scrollLeft >= overflow - 2;
    }

    /* ------------------- Mobile "show title on tap" ------------------ */
    /* First tap reveals the title, second tap follows the link. Desktop and
       the other two modes are pure CSS and never reach this code. */
    initTapTitles() {
      if (this.titleMode !== 'tap') return;

      const isTouch = () => window.matchMedia('(max-width: 749px)').matches;

      this.querySelectorAll('[data-media]').forEach((media) => {
        media.addEventListener('click', (event) => {
          if (!isTouch()) return;
          const card = media.closest('.pu10__card');
          if (!card || card.classList.contains('is-revealed')) return;
          event.preventDefault();
          this.clearRevealed();
          card.classList.add('is-revealed');
        });
      });

      this._onDocPointer = (event) => {
        if (this.contains(event.target)) return;
        this.clearRevealed();
      };
      document.addEventListener('pointerdown', this._onDocPointer);

      if (this.track) {
        this.track.addEventListener('scroll', () => this.clearRevealed(), { passive: true });
      }
    }

    clearRevealed() {
      this.querySelectorAll('.pu10__card.is-revealed').forEach((card) => card.classList.remove('is-revealed'));
    }

    /* --------------------------- Add to cart ------------------------ */
    initForms() {
      this.querySelectorAll('[data-atc-form]').forEach((form) => {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const field = form.querySelector('[name="id"]');
          if (!field) return;
          this.addToCart(field.value, form.querySelector('[data-atc]'));
        });
      });
    }

    async addToCart(variantId, button) {
      if (!variantId || (button && button.disabled)) return;
      if (button) button.disabled = true;

      try {
        const response = await fetch(this.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || this.errorLabel);

        if (button) button.classList.add('is-added');
        await this.afterAdd();
      } catch (error) {
        this.showToast(error.message || this.errorLabel);
      } finally {
        setTimeout(() => {
          if (button) {
            button.disabled = false;
            button.classList.remove('is-added');
          }
        }, 1400);
      }
    }

    /* Tell the theme the cart changed, open its drawer if it has one, else toast. */
    async afterAdd() {
      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'products-under-ten' });
        }
      } catch (e) { /* theme does not use PubSub */ }

      ['cart:refresh', 'cart:build', 'cart:updated', 'product:added', 'ajaxProduct:added'].forEach((name) => {
        const detail = { source: 'products-under-ten' };
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
        document.body.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
      });

      const drawer = document.querySelector(
        'cart-drawer, cart-notification, #CartDrawer, .js-drawer--cart, [data-cart-drawer]'
      );
      let opened = false;
      if (drawer) {
        try {
          if (typeof drawer.open === 'function') { drawer.open(); opened = true; }
          else if (typeof drawer.show === 'function') { drawer.show(); opened = true; }
        } catch (e) { opened = false; }
      }
      if (!opened) this.showToast(this.addedLabel);

      try {
        const cart = await fetch(this.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        document
          .querySelectorAll('[data-cart-count], .cart-count-bubble span:first-child, .cart-count, #CartCount')
          .forEach((node) => {
            if (node.getAttribute('aria-hidden') === 'true') return;
            node.textContent = cart.item_count;
          });
      } catch (e) { /* count refresh is best effort */ }
    }

    showToast(message) {
      const toast = this.querySelector('[data-toast]');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2400);
    }
  }

  customElements.define('products-under-ten', ProductsUnderTen);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-items"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window.customElements || customElements.get('shop-the-look')) return;

  const CARD_GAP = 12;
  const EDGE = 8;

  class ShopTheLook extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add';
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.labels = {
        atc: this.dataset.labelAtc || 'Add to cart',
        adding: this.dataset.labelAdding || 'Adding...',
        added: this.dataset.labelAdded || 'Added to cart',
        soldout: this.dataset.labelSoldout || 'Sold out',
        error: this.dataset.labelError || 'Could not add to cart'
      };

      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));

      this.initCarousel();
      this.initHotspots();
      this.initVariantSelects();
      this.initForms();
      this.initEditorHooks();
    }

    disconnectedCallback() {
      if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
      if (this._onKeydown) document.removeEventListener('keydown', this._onKeydown);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._onBlockSelect) document.removeEventListener('shopify:block:select', this._onBlockSelect);
      clearTimeout(this._toastTimer);
      clearTimeout(this._settleTimer);
    }

    /* --------------------------- Carousel --------------------------- */
    initCarousel() {
      if (!this.track) return;

      // Belt and braces for the wheel: overflow-y:hidden already stops the
      // track scrolling vertically, but if a future edit reintroduces vertical
      // overflow we still want the page to take a mostly-vertical wheel.
      this.track.addEventListener('wheel', (event) => {
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) this.track.scrollTop = 0;
      }, { passive: true });

      this.querySelectorAll('[data-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          this.closeCards();
          this.track.scrollBy({ left: Number(button.dataset.scroll) * this.track.clientWidth, behavior: 'smooth' });
        });
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.closeCards();
          const i = Number(dot.dataset.dot) - 1;
          this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
        });
      });

      this.track.addEventListener('scroll', () => {
        if (this._scrollRaf) cancelAnimationFrame(this._scrollRaf);
        this._scrollRaf = requestAnimationFrame(() => this.syncCarousel());
      }, { passive: true });

      this._onResize = () => {
        this.syncCarousel();
        const open = this.querySelector('[data-hotspot].is-open');
        if (open) this.positionCard(open);
      };
      window.addEventListener('resize', this._onResize);

      this.initDrag();
      this.syncCarousel();
    }

    /* ------------------------- Mouse drag --------------------------- */
    /* Mouse only. Touch already gets a native swipe with momentum and snap,
       and taking that over would only make it worse. */
    initDrag() {
      if (!this.track || this.slides.length < 2) return;

      const THRESHOLD = 5;      // px of travel before a press becomes a drag
      const ADVANCE = 0.15;     // share of a slide that commits to the next one

      let pointerId = null;
      let startX = 0;
      let startY = 0;
      let startScroll = 0;
      let dragging = false;

      const finish = (commit) => {
        if (pointerId === null) return;
        try { this.track.releasePointerCapture(pointerId); } catch (e) { /* already gone */ }
        pointerId = null;
        if (!dragging) return;

        dragging = false;
        this.track.classList.remove('is-dragging');

        // The click that follows the release must not open a hotspot card.
        this._justDragged = true;
        this._dragEndedAt = Date.now();

        const width = this.track.clientWidth || 1;
        const moved = this.track.scrollLeft - startScroll;
        const from = Math.round(startScroll / width);

        let target;
        if (commit && Math.abs(moved) > width * ADVANCE) target = from + (moved > 0 ? 1 : -1);
        else target = Math.round(this.track.scrollLeft / width);

        this.settleTo(Math.max(0, Math.min(target, this.slides.length - 1)));
      };

      this.track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        // Let people select text and use the dropdown inside an open card.
        if (event.target.closest('[data-card]')) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        startScroll = this.track.scrollLeft;
        dragging = false;
      });

      this.track.addEventListener('pointermove', (event) => {
        if (pointerId === null || event.pointerId !== pointerId) return;
        const dx = event.clientX - startX;

        if (!dragging) {
          // Sideways intent only, so a vertical mouse drag stays inert.
          if (Math.abs(dx) < THRESHOLD || Math.abs(dx) <= Math.abs(event.clientY - startY)) return;
          dragging = true;
          this.track.classList.add('is-dragging');
          this.closeCards();
          try { this.track.setPointerCapture(pointerId); } catch (e) { /* not fatal */ }
        }

        event.preventDefault();
        this.track.scrollLeft = startScroll - dx;
      });

      this.track.addEventListener('pointerup', () => finish(true));
      this.track.addEventListener('pointercancel', () => finish(false));

      // Capture phase: swallow the click before it reaches a marker.
      this.track.addEventListener('click', (event) => {
        if (!this._justDragged) return;
        this._justDragged = false;
        if (Date.now() - this._dragEndedAt > 400) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    /* Animate to a slide with snapping held off until the scroll lands. */
    settleTo(index) {
      const width = this.track.clientWidth || 1;
      const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.classList.add('is-settling');
      this.track.scrollTo({ left: index * width, behavior: reduced ? 'auto' : 'smooth' });

      clearTimeout(this._settleTimer);
      const done = () => {
        clearTimeout(this._settleTimer);
        this.track.classList.remove('is-settling');
      };
      if ('onscrollend' in this.track) this.track.addEventListener('scrollend', done, { once: true });
      this._settleTimer = setTimeout(done, reduced ? 60 : 600);
    }

    currentIndex() {
      if (!this.track || !this.track.clientWidth) return 0;
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }

    syncCarousel() {
      const index = this.currentIndex();

      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      // Keep offscreen slides out of the tab order. Card contents are already
      // excluded by visibility:hidden, and decorative links stay untouchable.
      this.slides.forEach((slide, i) => {
        slide.querySelectorAll('button, a, select, input').forEach((node) => {
          if (node.closest('[data-card]') || node.getAttribute('aria-hidden') === 'true') return;
          if (i === index) node.removeAttribute('tabindex');
          else node.setAttribute('tabindex', '-1');
        });
      });

      const prev = this.querySelector('[data-scroll="-1"]');
      const next = this.querySelector('[data-scroll="1"]');
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (prev) prev.disabled = this.track.scrollLeft <= 2;
      if (next) next.disabled = this.track.scrollLeft >= max - 2;
    }

    /* --------------------------- Hotspots --------------------------- */
    initHotspots() {
      this.querySelectorAll('[data-marker]').forEach((marker) => {
        marker.addEventListener('click', (event) => {
          event.stopPropagation();
          const hotspot = marker.closest('[data-hotspot]');
          const wasOpen = hotspot.classList.contains('is-open');
          this.closeCards();
          if (!wasOpen) this.openCard(hotspot);
        });
      });

      this.querySelectorAll('[data-card-close]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          const hotspot = button.closest('[data-hotspot]');
          this.closeCards();
          hotspot.querySelector('[data-marker]').focus();
        });
      });

      // Clicks inside a card must not bubble out and close it.
      this.querySelectorAll('[data-card]').forEach((card) => {
        card.addEventListener('click', (event) => event.stopPropagation());
      });

      this._onDocClick = () => this.closeCards();
      document.addEventListener('click', this._onDocClick);

      this._onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        const open = this.querySelector('[data-hotspot].is-open');
        if (!open) return;
        this.closeCards();
        open.querySelector('[data-marker]').focus();
      };
      document.addEventListener('keydown', this._onKeydown);

      if (this.track) {
        this.track.addEventListener('scroll', () => this.closeCards(), { passive: true });
      }
    }

    openCard(hotspot) {
      hotspot.classList.add('is-open');
      hotspot.querySelector('[data-marker]').setAttribute('aria-expanded', 'true');
      this.positionCard(hotspot);
    }

    closeCards() {
      this.querySelectorAll('[data-hotspot].is-open').forEach((hotspot) => {
        hotspot.classList.remove('is-open');
        hotspot.querySelector('[data-marker]').setAttribute('aria-expanded', 'false');
      });
    }

    /* Keep the card fully inside the image: flip it above the marker when there
       is no room below, and clamp it horizontally to the image edges. This also
       keeps every card inside the track's clipping box. */
    positionCard(hotspot) {
      const card = hotspot.querySelector('[data-card]');
      const media = hotspot.closest('[data-media]');
      if (!card || !media) return;

      card.style.left = '0px';
      card.style.top = '0px';

      const mediaRect = media.getBoundingClientRect();
      const spotRect = hotspot.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();

      const spotLeft = spotRect.left - mediaRect.left;
      const spotTop = spotRect.top - mediaRect.top;
      const spotCenterX = spotLeft + spotRect.width / 2;

      // Horizontal: centre on the marker, then clamp inside the image.
      let left = spotCenterX - cardRect.width / 2;
      const maxLeft = mediaRect.width - cardRect.width - EDGE;
      left = Math.max(EDGE, Math.min(left, Math.max(EDGE, maxLeft)));

      // Vertical: below the marker unless that overflows, then above.
      const below = spotTop + spotRect.height + CARD_GAP;
      const above = spotTop - CARD_GAP - cardRect.height;
      let top = below;
      if (below + cardRect.height > mediaRect.height - EDGE && above >= EDGE) top = above;
      top = Math.max(EDGE, Math.min(top, Math.max(EDGE, mediaRect.height - cardRect.height - EDGE)));

      card.style.left = (left - spotLeft) + 'px';
      card.style.top = (top - spotTop) + 'px';
    }

    /* ------------------------ Variant selects ----------------------- */
    initVariantSelects() {
      this.querySelectorAll('[data-variant-select]').forEach((select) => {
        select.addEventListener('change', () => {
          const card = select.closest('[data-card]');
          const option = select.options[select.selectedIndex];
          if (!card || !option) return;

          const current = card.querySelector('[data-price-current]');
          const compare = card.querySelector('[data-price-compare]');
          const atc = card.querySelector('[data-atc]');

          if (current) current.textContent = option.dataset.price || '';
          if (compare) {
            const value = option.dataset.compare || '';
            compare.textContent = value;
            compare.hidden = value === '';
          }
          if (atc) {
            const available = option.dataset.available === 'true';
            atc.disabled = !available;
            atc.textContent = available ? this.labels.atc : this.labels.soldout;
          }
        });
      });
    }

    /* --------------------------- Add to cart ------------------------ */
    initForms() {
      this.querySelectorAll('[data-atc-form]').forEach((form) => {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const field = form.querySelector('[name="id"]');
          if (!field) return;
          this.addToCart(field.value, 1, form.querySelector('[data-atc]'));
        });
      });
    }

    async addToCart(variantId, quantity, button) {
      if (!variantId) return;

      const original = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = this.labels.adding;
      }

      try {
        const response = await fetch(this.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || this.labels.error);

        if (button) button.textContent = this.labels.added;
        await this.afterAdd();
      } catch (error) {
        this.showToast(error.message || this.labels.error);
      } finally {
        setTimeout(() => {
          if (button) {
            button.disabled = false;
            button.textContent = original || this.labels.atc;
          }
        }, 1200);
      }
    }

    /* Tell the theme the cart changed, open its drawer if it has one, else toast. */
    async afterAdd() {
      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'shop-the-look' });
        }
      } catch (e) { /* theme does not use PubSub */ }

      ['cart:refresh', 'cart:build', 'cart:updated', 'product:added', 'ajaxProduct:added'].forEach((name) => {
        const detail = { source: 'shop-the-look' };
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
        document.body.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
      });

      const drawer = document.querySelector(
        'cart-drawer, cart-notification, #CartDrawer, .js-drawer--cart, [data-cart-drawer]'
      );
      let opened = false;
      if (drawer) {
        try {
          if (typeof drawer.open === 'function') { drawer.open(); opened = true; }
          else if (typeof drawer.show === 'function') { drawer.show(); opened = true; }
        } catch (e) { opened = false; }
      }
      if (!opened) this.showToast(this.labels.added);

      try {
        const cart = await fetch(this.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        document
          .querySelectorAll('[data-cart-count], .cart-count-bubble span:first-child, .cart-count, #CartCount')
          .forEach((node) => {
            if (node.getAttribute('aria-hidden') === 'true') return;
            node.textContent = cart.item_count;
          });
      } catch (e) { /* count refresh is best effort */ }
    }

    showToast(message) {
      const toast = this.querySelector('[data-toast]');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
    }

    /* ------------------------- Theme editor ------------------------- */
    initEditorHooks() {
      if (!window.Shopify || !window.Shopify.designMode) return;

      this._onBlockSelect = (event) => {
        const slide = this.querySelector('[data-block-id="' + event.detail.blockId + '"]');
        if (!slide || !this.track) return;
        this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      };
      document.addEventListener('shopify:block:select', this._onBlockSelect);
    }
  }

  customElements.define('shop-the-look', ShopTheLook);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-carousel-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Guard: this file may render many times on one page; define the element once.
  if (!window.customElements || customElements.get('tabbed-product-carousel')) return;

  // Built piecewise so no literal Liquid-looking braces appear in this file.
  var DEFAULT_MONEY_FORMAT = '$' + '{' + '{amount}' + '}';
  var MONEY_RX = /\{\{\s*(\w+)\s*\}\}/;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || DEFAULT_MONEY_FORMAT;
    var match = fmt.match(MONEY_RX);
    var name = match ? match[1] : 'amount';

    function build(precision, thousands, decimal) {
      var n = (Number(cents) / 100).toFixed(precision);
      var parts = n.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return precision ? head + decimal + parts[1] : head;
    }

    var value;
    switch (name) {
      case 'amount_no_decimals': value = build(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = build(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = build(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = build(2, "'", '.'); break;
      case 'amount_with_space_separator': value = build(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = build(0, ' ', '.'); break;
      default: value = build(2, ',', '.');
    }
    return fmt.replace(MONEY_RX, value);
  }

  class TabbedProductCarousel extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add';
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.moneyFormat = this.dataset.moneyFormat || DEFAULT_MONEY_FORMAT;
      this.labels = {
        atc: this.dataset.labelAtc || 'Add to cart',
        adding: this.dataset.labelAdding || 'Adding...',
        added: this.dataset.labelAdded || 'Added to cart',
        soldout: this.dataset.labelSoldout || 'Sold out',
        error: this.dataset.labelError || 'Could not add to cart',
        optionsNote: this.dataset.labelOptionsNote || ''
      };

      this.initTabs();
      this.initArrows();
      this.initCardForms();
      this.initQuickLook();
    }

    disconnectedCallback() {
      if (this._onKeydown) document.removeEventListener('keydown', this._onKeydown);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._ro) this._ro.disconnect();
      clearTimeout(this._toastTimer);
      document.body.style.overflow = '';
    }

    /* ---------------------------- Tabs ---------------------------- */
    initTabs() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      if (!this.tabs.length) return;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectTab(index, false));
        tab.addEventListener('keydown', (event) => {
          const last = this.tabs.length - 1;
          let next = null;
          if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
          else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = last;
          if (next !== null) {
            event.preventDefault();
            this.selectTab(next, true);
          }
        });
      });
    }

    selectTab(index, moveFocus) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (active && moveFocus) tab.focus();
      });

      const id = this.tabs[index].dataset.tab;
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.panel !== id;
      });

      // Track widths are only measurable once the panel is visible.
      requestAnimationFrame(() => this.updateArrows());
    }

    /* --------------------------- Arrows --------------------------- */
    initArrows() {
      this.querySelectorAll('[data-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          const viewport = button.closest('.tpc__viewport');
          const track = viewport && viewport.querySelector('[data-track]');
          if (!track) return;
          const card = track.querySelector('.tpc__card');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
          const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
          track.scrollBy({ left: Number(button.dataset.scroll) * step * 2, behavior: 'smooth' });
        });
      });

      this.querySelectorAll('[data-track]').forEach((track) => {
        track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      });

      if (typeof ResizeObserver === 'function') {
        this._ro = new ResizeObserver(() => this.updateArrows());
        this._ro.observe(this);
      } else {
        this._onResize = () => this.updateArrows();
        window.addEventListener('resize', this._onResize);
      }

      this.updateArrows();
    }

    updateArrows() {
      this.querySelectorAll('.tpc__viewport').forEach((viewport) => {
        const track = viewport.querySelector('[data-track]');
        const prev = viewport.querySelector('[data-scroll="-1"]');
        const next = viewport.querySelector('[data-scroll="1"]');
        if (!track) return;
        const overflow = track.scrollWidth - track.clientWidth;
        if (prev) prev.hidden = overflow <= 2 || track.scrollLeft <= 2;
        if (next) next.hidden = overflow <= 2 || track.scrollLeft >= overflow - 2;
      });
    }

    /* ---------------------- Card add to cart ---------------------- */
    initCardForms() {
      this.querySelectorAll('[data-atc-form]').forEach((form) => {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const button = form.querySelector('[data-atc]');
          const input = form.querySelector('input[name="id"]');
          if (!input) return;
          this.addToCart(input.value, 1, button);
        });
      });
    }

    async addToCart(variantId, quantity, button) {
      if (!variantId) return;

      const original = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = this.labels.adding;
      }

      try {
        const response = await fetch(this.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }]
          })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || this.labels.error);

        if (button) button.textContent = this.labels.added;
        if (this.modal && !this.modal.hidden) this.closeModal();
        await this.afterAdd();
      } catch (error) {
        this.showToast(error.message || this.labels.error);
      } finally {
        setTimeout(() => {
          if (button) {
            button.disabled = false;
            button.textContent = original || this.labels.atc;
          }
        }, 1200);
      }
    }

    /* Tell the theme the cart changed, open its drawer if it has one, else toast. */
    async afterAdd() {
      // Dawn and its derivatives use a PubSub bus.
      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'tabbed-product-carousel' });
        }
      } catch (e) { /* theme does not use PubSub */ }

      // Common DOM events used by other theme families.
      ['cart:refresh', 'cart:build', 'cart:updated', 'product:added', 'ajaxProduct:added'].forEach((name) => {
        const detail = { source: 'tabbed-product-carousel' };
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
        document.body.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
      });

      const drawer = document.querySelector(
        'cart-drawer, cart-notification, #CartDrawer, .js-drawer--cart, [data-cart-drawer]'
      );
      let opened = false;
      if (drawer) {
        try {
          if (typeof drawer.open === 'function') { drawer.open(); opened = true; }
          else if (typeof drawer.show === 'function') { drawer.show(); opened = true; }
        } catch (e) { opened = false; }
      }
      if (!opened) this.showToast(this.labels.added);

      // Keep the header count honest whichever theme this ends up in.
      try {
        const cart = await fetch(this.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        document
          .querySelectorAll('[data-cart-count], .cart-count-bubble span:first-child, .cart-count, #CartCount')
          .forEach((node) => {
            if (node.getAttribute('aria-hidden') === 'true') return;
            node.textContent = cart.item_count;
          });
      } catch (e) { /* count refresh is best effort */ }
    }

    showToast(message) {
      const toast = this.querySelector('[data-toast]');
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
    }

    /* -------------------------- Quick Look ------------------------- */
    initQuickLook() {
      this.modal = this.querySelector('[data-modal]');
      if (!this.modal) return;

      this.qtyInput = this.modal.querySelector('[data-modal-qty]');

      this.querySelectorAll('[data-quick-look]').forEach((button) => {
        button.addEventListener('click', () => {
          this.lastFocus = button;
          this.openModal(button.dataset.productUrl);
        });
      });

      this.modal.querySelectorAll('[data-modal-close]').forEach((node) => {
        node.addEventListener('click', () => this.closeModal());
      });

      this._onKeydown = (event) => {
        if (event.key === 'Escape' && !this.modal.hidden) this.closeModal();
      };
      document.addEventListener('keydown', this._onKeydown);

      // Quantity stepper.
      this.modal.querySelectorAll('[data-qty-step]').forEach((button) => {
        button.addEventListener('click', () => {
          this.setQty(this.getQty() + Number(button.dataset.qtyStep));
        });
      });
      if (this.qtyInput) {
        this.qtyInput.addEventListener('change', () => this.setQty(this.getQty()));
        this.qtyInput.addEventListener('blur', () => this.setQty(this.getQty()));
      }

      const add = this.modal.querySelector('[data-modal-add]');
      if (add) {
        add.addEventListener('click', (event) => {
          this.addToCart(this.currentVariant && this.currentVariant.id, this.getQty(), event.currentTarget);
        });
      }
    }

    getQty() {
      const raw = parseInt(this.qtyInput && this.qtyInput.value, 10);
      return Math.max(1, isNaN(raw) ? 1 : raw);
    }

    setQty(value) {
      const qty = Math.max(1, Math.floor(Number(value) || 1));
      if (this.qtyInput) this.qtyInput.value = qty;
      const minus = this.modal.querySelector('[data-qty-step="-1"]');
      if (minus) minus.disabled = qty <= 1;
    }

    async openModal(url) {
      if (!url) return;
      const dialog = this.modal.querySelector('.tpc__dialog');
      this.modal.hidden = false;
      dialog.classList.add('is-loading');
      dialog.scrollTop = 0;
      document.body.style.overflow = 'hidden';
      this.setQty(1);

      const close = this.modal.querySelector('.tpc__close');
      if (close) close.focus();

      try {
        const response = await fetch(url + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product not found');
        this.product = await response.json();
        this.productUrl = url;
        this.renderModal(this.product);
        dialog.classList.remove('is-loading');
      } catch (e) {
        this.closeModal();
        this.showToast(this.labels.error);
      }
    }

    closeModal() {
      this.modal.hidden = true;
      document.body.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
    }

    renderModal(product) {
      const q = (selector) => this.modal.querySelector(selector);

      q('[data-modal-title]').textContent = product.title;
      const mainImage = q('[data-modal-image]');
      mainImage.src = product.featured_image || '';
      mainImage.alt = product.title;
      q('[data-modal-view]').href = this.productUrl;

      // Thumbnails
      const thumbs = q('[data-modal-thumbs]');
      thumbs.innerHTML = '';
      const images = product.images || [];
      images.slice(0, 8).forEach((src, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'View image ' + (i + 1));
        button.setAttribute('aria-current', i === 0 ? 'true' : 'false');

        const img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        button.appendChild(img);

        button.addEventListener('click', () => {
          mainImage.src = src;
          thumbs.querySelectorAll('button').forEach((b) => b.setAttribute('aria-current', 'false'));
          button.setAttribute('aria-current', 'true');
        });

        thumbs.appendChild(button);
      });
      thumbs.hidden = images.length < 2;

      // No variant pickers here by design. Multi-variant products get a nudge
      // toward the product page, where the real picker lives.
      const note = q('[data-modal-note]');
      if (note) {
        const many = (product.variants || []).length > 1;
        note.textContent = many ? this.labels.optionsNote : '';
        note.hidden = !many || !this.labels.optionsNote;
      }

      this.syncVariant();
    }

    /* Quick Look always works on the first available variant. */
    syncVariant() {
      const product = this.product;
      const variants = (product && product.variants) || [];
      const variant = variants.find((v) => v.available) || variants[0];

      this.currentVariant = variant;

      const price = this.modal.querySelector('[data-modal-price]');
      const addButton = this.modal.querySelector('[data-modal-add]');
      const view = this.modal.querySelector('[data-modal-view]');

      if (!variant) {
        price.textContent = '';
        addButton.disabled = true;
        addButton.textContent = this.labels.soldout;
        return;
      }

      price.textContent = formatMoney(variant.price, this.moneyFormat);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const compare = document.createElement('s');
        compare.textContent = formatMoney(variant.compare_at_price, this.moneyFormat);
        price.appendChild(compare);
      }

      if (variant.featured_image && variant.featured_image.src) {
        this.modal.querySelector('[data-modal-image]').src = variant.featured_image.src;
      }

      view.href = this.productUrl + '?variant=' + variant.id;
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? this.labels.atc : this.labels.soldout;
    }
  }

  customElements.define('tabbed-product-carousel', TabbedProductCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
